/**
 * One modal at a time (#121, #123): Confirm, Name and Move dialogs open in
 * call order; the next waits until the previous one calls `done` (its hidden
 * event). A throwing opener releases the queue instead of blocking it.
 */

let queue: Promise<void> = Promise.resolve();

export function enqueueDialog(open: (done: () => void) => void): void {
  // catch(): a rejected predecessor must never block later dialogs.
  queue = queue
    .catch(() => undefined)
    .then(() => new Promise<void>((done) => open(done)));
}
